// JD1 Works 2.0.44 · CP-MCAT01 V1.5 · Retail Mega Categories

class JD1RetailMenu extends HTMLElement {
  connectedCallback() {
    if (this._connected) return;
    this._connected = true;

    this.trigger = this.querySelector('[data-jd1-retail-trigger]');
    this.panel = this.querySelector('[data-jd1-retail-panel]');
    this.closeButtons = this.querySelectorAll('[data-jd1-retail-close]');
    this.departments = this.querySelectorAll('[data-jd1-retail-dept]');
    this.groups = this.querySelectorAll('[data-jd1-retail-group]');
    this.promos = this.querySelectorAll('[data-jd1-retail-promo]');
    this.searchInput = this.querySelector('[data-jd1-retail-search]');
    this.mobileRoot = this.querySelector('[data-jd1-retail-mobile-root]');
    this.mobileSubs = this.querySelectorAll('[data-jd1-retail-mobile-sub]');
    this.mobileTitle = this.querySelector('[data-jd1-retail-mobile-title]');
    this.backButton = this.querySelector('[data-jd1-retail-back]');
    this.defaultMobileTitle = this.mobileTitle ? this.mobileTitle.textContent : '';

    this.trigger?.addEventListener('click', this.toggle.bind(this));
    this.closeButtons.forEach((button) => button.addEventListener('click', this.close.bind(this)));
    this.departments.forEach((department) => {
      department.addEventListener('mouseenter', () => this.activate(department.dataset.jd1RetailDept));
      department.addEventListener('focus', () => this.activate(department.dataset.jd1RetailDept));
      department.addEventListener('click', (event) => {
        if (department.getAttribute('href') && this.classList.contains('is-open')) {
          const hasGroup = this.querySelector(`[data-jd1-retail-group="${department.dataset.jd1RetailDept}"]`);
          if (hasGroup) event.preventDefault();
        }
        this.activate(department.dataset.jd1RetailDept);
      });
    });

    this.querySelectorAll('[data-jd1-retail-mobile-open]').forEach((button) => {
      button.addEventListener('click', () => this.openMobileSub(button.dataset.jd1RetailMobileOpen, button.dataset.jd1RetailMobileLabel));
    });
    this.backButton?.addEventListener('click', this.showMobileRoot.bind(this));
    this.searchInput?.addEventListener('input', this.filterItems.bind(this));

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });

    document.addEventListener('click', (event) => {
      if (!this.classList.contains('is-open')) return;
      if (!this.contains(event.target)) this.close();
    });
  }

  toggle(event) {
    event?.preventDefault();
    this.classList.contains('is-open') ? this.close() : this.open();
  }

  open() {
    this.classList.add('is-open');
    this.panel?.removeAttribute('hidden');
    this.querySelector('.jd1-retail__scrim')?.removeAttribute('hidden');
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('jd1-retail-is-open');
    document.documentElement.classList.toggle('jd1-retail-drawer-open', this.dataset.jd1RetailMode === 'drawer');
  }

  close() {
    this.classList.remove('is-open');
    this.trigger?.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => {
      if (this.classList.contains('is-open')) return;
      this.panel?.setAttribute('hidden', '');
      this.querySelector('.jd1-retail__scrim')?.setAttribute('hidden', '');
      this.showMobileRoot();
      if (this.searchInput) {
        this.searchInput.value = '';
        this.filterItems();
      }
    }, 200);
    document.documentElement.classList.remove('jd1-retail-is-open');
    document.documentElement.classList.remove('jd1-retail-drawer-open');
  }

  activate(index = '0') {
    this.departments.forEach((item) => item.classList.toggle('is-active', item.dataset.jd1RetailDept === String(index)));
    this.groups.forEach((group) => {
      const active = group.dataset.jd1RetailGroup === String(index);
      group.classList.toggle('is-active', active);
      group.toggleAttribute('hidden', !active);
    });
    this.promos.forEach((promo) => {
      const active = promo.dataset.jd1RetailPromo === String(index);
      promo.classList.toggle('is-active', active);
      promo.toggleAttribute('hidden', !active);
    });
  }

  openMobileSub(index = '0', label = '') {
    this.mobileRoot?.setAttribute('hidden', '');
    this.mobileSubs.forEach((sub) => sub.toggleAttribute('hidden', sub.dataset.jd1RetailMobileSub !== String(index)));
    this.backButton?.classList.remove('is-hidden');
    if (this.mobileTitle) this.mobileTitle.textContent = label || this.defaultMobileTitle;
    if (this.searchInput) {
      this.searchInput.value = '';
      this.filterItems();
    }
  }

  showMobileRoot() {
    this.mobileRoot?.removeAttribute('hidden');
    this.mobileSubs.forEach((sub) => sub.setAttribute('hidden', ''));
    this.backButton?.classList.add('is-hidden');
    if (this.mobileTitle) this.mobileTitle.textContent = this.defaultMobileTitle;
  }

  filterItems() {
    const query = (this.searchInput?.value || '').trim().toLowerCase();
    this.querySelectorAll('[data-jd1-retail-search-item]').forEach((item) => {
      const text = (item.dataset.jd1RetailSearchText || item.textContent || '').toLowerCase();
      item.classList.toggle('is-hidden-search', Boolean(query) && !text.includes(query));
    });
  }
}

if (!customElements.get('jd1-retail-menu')) {
  customElements.define('jd1-retail-menu', JD1RetailMenu);
}